import { render, staticRenderFns } from "./step-description-tenure.vue?vue&type=template&id=fddb7900"
import script from "./step-description-tenure.vue?vue&type=script&lang=ts"
export * from "./step-description-tenure.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports